import React, { useMemo } from 'react'

import { CloudDownloadOutlined } from '@ant-design/icons'
import { Badge } from 'antd'

import { reportStatus, useGetBackgroundReportsQuery, useReportsDrawerState } from '../../../appRedux/ducks/reports'
import styles from './styles.module.less'

export const BackgroundReportsIcon = () => {
  const { toggleShowDrawer } = useReportsDrawerState()

  const { data: reports = [] } = useGetBackgroundReportsQuery()

  const completedReportsCount = useMemo(
    () => reports.filter((report) => report.status === reportStatus.COMPLETED).length,
    [reports]
  )

  return (
    <li onClick={toggleShowDrawer}>
      <div className={styles['icon-wrapper']}>
        <Badge
          count={completedReportsCount}
          className={styles['reports-count-badge']}
          style={{ backgroundColor: '#843EF7', marginTop: 4 }}
        >
          <CloudDownloadOutlined className={styles['cloud-download-icon']} />
        </Badge>
      </div>
    </li>
  )
}
